import { render, staticRenderFns } from "./MultiCheckResults.vue?vue&type=template&id=55de0296&"
import script from "./MultiCheckResults.vue?vue&type=script&lang=js&"
export * from "./MultiCheckResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports